/** Basit API istemcisi — oturum çerezini daima gönderir (credentials: include). */

export interface ApiError {
  error: string;
  fields?: Record<string, string[]>;
}

export class ApiRequestError extends Error {
  status: number;
  fields?: Record<string, string[]>;
  constructor(status: number, body: ApiError) {
    super(body.error || 'İstek başarısız');
    this.status = status;
    this.fields = body.fields;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`/api${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new ApiRequestError(res.status, data as ApiError);
  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
  del: <T>(path: string) => request<T>('DELETE', path),
};
